import { IHoatDongHangNgaySelectRequest } from "../../../models/request/danh-gia/IHoatDongHangNgaySelectRequest"
import { IHoatDongHangNgaySubmitRequest } from "../../../models/request/danh-gia/IHoatDongHangNgaySubmitRequest"
import { IDiemDanh } from "../../../models/response/danh-gia/IDiemDanh"
import { IHoatDongHangNgayRespone } from "../../../models/response/danh-gia/IHoatDongHangNgayRespone"
import { INhanXetHangNgay } from "../../../models/response/danh-gia/INhanXetHangNgay"
import { INhanXetHangNgayLop } from "../../../models/response/danh-gia/INhanXetHangNgayLop"
import { IDonTraModalInfo } from "../../page-state-model/danh-gia/IHoatDongHangNgayReducer"
import { generateActionTypeIds } from "../generateActionTypeIds"
import IGenericActionType from "../IGenericActionType"


export const eHoatDongHangNgayActionTypeDefine = {
    CHANGE_FILTER: {} as IHoatDongHangNgaySelectRequest,

    LOAD_START: {} as IHoatDongHangNgaySelectRequest,
    LOAD_SUCCESS: {} as IHoatDongHangNgayRespone,
    LOAD_ERROR: "",

    SHOW_DIEM_DANH_MODAL: false,
    SHOW_NHAN_XET_MODAL: false,

    SUBMIT_DIEM_DANH_START: {} as IHoatDongHangNgaySubmitRequest<IDiemDanh[]>,
    SUBMIT_DIEM_DANH_SUCCESS: {} as IDiemDanh[],
    SUBMIT_DIEM_DANH_ERROR: "",

    SUBMIT_NHAN_XET_LOP_START: {} as IHoatDongHangNgaySubmitRequest<INhanXetHangNgayLop>,
    SUBMIT_NHAN_XET_LOP_SUCCESS: {} as INhanXetHangNgayLop,
    SUBMIT_NHAN_XET_LOP_ERROR: "",

    SUBMIT_NHAN_XET_HOC_SINH_START: {} as IHoatDongHangNgaySubmitRequest<INhanXetHangNgay[]>,
    SUBMIT_NHAN_XET_HOC_SINH_SUCCESS: {} as INhanXetHangNgay[],
    SUBMIT_NHAN_XET_HOC_SINH_ERROR: "",

    CHANGE_DON_TRE_MODAL: {} as IDonTraModalInfo,
    CHANGE_TRA_TRE_MODAL: {} as IDonTraModalInfo,


}
export const eHoatDongHangNgayActionTypeIds = generateActionTypeIds(eHoatDongHangNgayActionTypeDefine, "HOAT_DONG_HANG_NGAY")

export type IHoatDongHangNgayActions = IGenericActionType<typeof eHoatDongHangNgayActionTypeDefine, "HOAT_DONG_HANG_NGAY">